<script>
export default {
    name: 'IconBurger',
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="base-icon icon-burger" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M64 50.2V58H0v-7.8h64Zm0-22.1v7.8H0v-7.8h64ZM64 6v7.8H0V6h64Z" clip-rule="evenodd"/></svg>
</template>
